export default __webpack_public_path__ + "static/media/case_11.bf3a7047.jpg";